import PropTypes from 'prop-types';
import ImageProp from './ImageProp';
import {
  PRODUCT_VIEW,
  PRODUCT_VIEWS,
  PRODUCT_ITEM_TYPES,
  PRODUCT_TYPE,
  PRODUCT_TYPES,
  PLAN_TYPES,
  LICENSE_TYPES,
} from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  tiersUsers: PropTypes.arrayOf(
    PropTypes.shape({
      flatAmount: PropTypes.number,
      unitAmount: PropTypes.number,
      minimumRange: PropTypes.number,
      maximumRange: PropTypes.number,
    }),
  ),
  description: PropTypes.string.isRequired,
  type: PropTypes.oneOf(PRODUCT_TYPES).isRequired,
  itemType: PropTypes.oneOf(PRODUCT_ITEM_TYPES),
  displayOnView: PropTypes.oneOf(PRODUCT_VIEWS),
  allowQuantity: PropTypes.bool.isRequired,
  isFreeTrial: PropTypes.bool.isRequired,
  isBought: PropTypes.bool.isRequired,
  requiredPlans: PropTypes.arrayOf(PropTypes.oneOf(PLAN_TYPES)),
  requiredLicenseTypes: PropTypes.arrayOf(PropTypes.oneOf(LICENSE_TYPES)),
  belongsToPack: PropTypes.bool,
  isInCart: PropTypes.bool,
  isSubscription: PropTypes.bool,
  showBought: PropTypes.bool,
  images: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
  video: PropTypes.shape({
    url: PropTypes.string,
    thumb: PropTypes.string,
  }),
  interval: PropTypes.string,
};

const defaultProp = {
  _id: '',
  price: 0,
  tiersUsers: [],
  name: '',
  description: '',
  type: PRODUCT_TYPE.MULTI_BUY,
  itemType: null,
  displayOnView: PRODUCT_VIEW.OPTIONS,
  allowQuantity: false,
  isFreeTrial: false,
  requiredPlans: [],
  requiredLicenseTypes: [],
  isBought: false,
  image: '/images/trophy.svg',
  belongsToPack: false,
  isInCart: false,
  isSubscription: false,
  showBought: false,
  images: [],
  video: null,
  interval: 'none',
};

export default { propType, defaultProp };
